export const ProductShape = {
	RectangleA: {
		height: "11rem"
	},
	RectangleB: {
		height: "14.75rem"
	}
};

export interface Item {
	[index: number]: any;
}

export interface DragPoint {
	x: number;
	y: number;
}

export interface DragPoints {
	startPoint?: DragPoint;
	endPoint?: DragPoint;
}

export interface CalendarData {
	isRemindMe: boolean;
	gpid: string;
	name: string;
	start: string;
	end: string;
	index: number;
	activeId: string;
}

export const productLimit: number = 20;
export const flashMultiTabLimit: number = 200;
export const flashNoTabLimit: number = 30;

export interface Attrs {
	[index: number]: string;
}

export interface ObjItem {
	[name: string]: string;
}

// 当页面什么都不配置的时候，页面的固定高度（m站的头）
export const pageFixedHeight: number = 2.75;
